import React from "react";
import {observer} from "mobx-react";
import FieldErrors from "../base/FieldErrors";
import Label from "./Label";
import {useErrors} from "@morningtrain/react-resources";
import PropTypes from "prop-types";
import startCase from "lodash/startCase";

function FieldWrapper(props) {

    const {id, label, name, children, required, className} = props;

    const errors = useErrors(name);

    let classNames = [
        'form-element',
        className,
        (errors !== null && errors.size && errors.size > 0) ? 'has-error' : null,
    ].filter(c => c).join(' ');

    const labelJSX = label === false ? null : (
        <Label forHtml={id}>
            <span>{label || startCase(name)}</span>
            {(required === true) ? (
                <abbr className={'is-required'}>*</abbr>
            ) : null}
        </Label>
    );

    return (
        <div className={classNames}>
            {labelJSX}
            <FieldErrors name={name}/>
            {children}
        </div>
    );

}

FieldWrapper.defaultProps = {
    id: null,
    required: false,
    label: null,
    className: "",
    name: '',
};

FieldWrapper.propTypes = {
    name: PropTypes.string,
    id: PropTypes.string,
    required: PropTypes.bool,
    label: PropTypes.node,
    className: PropTypes.string,
}

export default observer(FieldWrapper);
